import { Controller } from "@hotwired/stimulus"

// When this controller is added to a link with class "hidden", it enqueues a
// callback to be run when Didomi is ready. If the current user is subject to a
// regulation (which can only be "gdpr" at time of writing), the link is
// revealed. Clicking the link runs show(), which opens the Didomi preferences
// modal.
export default class extends Controller {
  connect() {
    window.didomiOnReady = window.didomiOnReady || []
    window.didomiOnReady.push(() => {
      if (window.Didomi.getCurrentUserStatus().regulation !== "none") {
        this.element.classList.remove("hidden")
      }
    })
  }

  show(event) {
    event.preventDefault()
    window.Didomi.preferences.show()
  }
}
